import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { GridActionsCellItem } from '@mui/x-data-grid'
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons'
import { Tooltip } from '@vapor/material'

export const Action = ({
  onClick,
  icon,
  label,
  color,
  showLabelInTooltip,
  showInMenu,
  disabled = false,
  hidden,
}: {
  icon: IconDefinition
  label: string
  color?: string
  onClick?: (event: unknown) => void
  showLabelInTooltip?: true
  showInMenu?: true
  disabled?: boolean
  hidden?: boolean
}) => {
  return (
    <>
      <Tooltip title={showLabelInTooltip ? label : undefined}>
        <span>
          <GridActionsCellItem //
            icon={<FontAwesomeIcon icon={icon} color={color ?? 'var(--DarkImperialBlue)'} opacity={disabled ? 0.5 : 1} />}
            label={label}
            className="textPrimary"
            onClick={onClick}
            color="inherit"
            showInMenu={showInMenu}
            disabled={disabled}
            hidden={hidden}
          />
        </span>
      </Tooltip>
    </>
  )
}
